import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardJump from '@swf/core/hooks/useWizardJump';

import { getPaymentVerificationPath } from '../../../utils/cashier';
import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_Before_you_can_depositX_we_nee_ELL_3,
  TXTWCL_Continue,
  TXTWCL_Just_a_moment_1
} from './MethodVerificationRequired.messages.json';
import { messageText } from './MethodVerificationRequired.scss';

interface Props {
  onClose(): void;
}

const MethodVerificationRequired: React.FC<Props> = ({ onClose }) => {
  const wizardJump = useWizardJump();

  const {
    data: { cashierFlow }
  } = useWizardContext();

  const jumpToPaymentVerification = () => {
    wizardJump.jumpForward(getPaymentVerificationPath(cashierFlow));
  };
  return (
    <Prompt
      onClose={onClose}
      variant="info"
      title={{ translation: TXTWCL_Just_a_moment_1 }}
      primaryButton={{
        translation: TXTWCL_Continue
      }}
      onPrimaryButtonClick={jumpToPaymentVerification}
    >
      <div className={messageText}>
        <Translation {...TXTWCL_Before_you_can_depositX_we_nee_ELL_3} />
      </div>
    </Prompt>
  );
};

export default MethodVerificationRequired;
